export enum ItemStatus {
  Initiated = 'Initiated',
  InProgress = 'InProgress',
  Failed = 'Failed',
  Succeeded = 'Succeeded',
  SucceededWithErrors = 'SucceededWithErrors',
  SucceededWithDuplicates = 'SucceededWithDuplicates'
}
